import * as React from 'react';
import { Table } from "soprasteria-ui-library";
import { dateTimeToDateString } from '../../../helpers/DateHelper';
import { IReferralComment } from '../../../models/IReferral';

interface IReferralComments {
    referralComments?: IReferralComment[];
}

export const ReferralComments: React.FunctionComponent<IReferralComments> = ({ referralComments }) => {

    return (
        <>
            {
                referralComments && referralComments.length > 0
                    ?
                    <>
                        <hr />
                        <div className="row readonly-less-margin">
                            <h5 className="col-12">Remisskommentarer</h5>
                            <div className="col-12">
                                <Table>
                                    <thead>
                                        <tr>
                                            <th>Datum</th>
                                            <th>Kommentar</th>
                                            <th>Typ av kommentar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            referralComments.map((comment, key) =>
                                                <tr key={key}>
                                                    <td>{dateTimeToDateString(comment.date)}</td>
                                                    <td>{comment.description}</td>
                                                    <td>{comment.category}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </>
                    : null
            }
        </>
    );
}